/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request schema to update an ongoing Curai visit from another Nori conversation
 */
export interface UpdateCuraiVisitRequest {
  /** The ID of the new Nori conversation */
  conversation_id: string;
  /** The ID of the clinic request */
  clinic_request_id?: string | null;
}
